export default "__VITE_ASSET__d9b3dbd4__"